import React from 'react';
import {Link} from 'react-router-dom';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_LEFT__16} from '@homeaway/svg-defs/lib/defs/CHEVRON_LEFT__16';
import {Button} from '@homeaway/react-buttons';
import routes from '../../routes';

import './back-to-scratchpad-button.less';

function BackToScratchpadButton({buttonText}) {
    return (
        <Link className="recent-activity-back-button" to={routes.TRIPBOARD} >
            <Button
                aria-label={buttonText}
                className="recent-activity-back-button"
                label={
                    <React.Fragment>
                        <span>{buttonText}</span>
                        <SVGIcon inlineFlex markup={CHEVRON_LEFT__16}/>
                    </React.Fragment>
                }
            />
        </Link>
    );
}

export default BackToScratchpadButton;



// WEBPACK FOOTER //
// ./src/universal/recent-activity/components/back-to-scratchpad-button.js